/** @jsxImportSource @emotion/react */

import {
  css,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BaseButton from "components/common/Button/Base";
import { PALETTE } from "styles/base/variables";

export type AlertType = "error" | "warning" | "info" | "success";
export interface AlertData {
  message: string | React.ReactNode;
  type?: AlertType;
  confirmFunc?: () => void;
}

interface AlertDialogProps {
  isOpen: boolean;
  setIsOpen: (arg: boolean) => void;
  alertData?: AlertData;
}

function AlertDialog({ isOpen, setIsOpen, alertData }: AlertDialogProps) {
  const closeDialog = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Dialog open={isOpen} onClose={alertData?.confirmFunc || closeDialog}>
        <DialogTitle
          css={css`
            margin-left: -2px;
            padding-bottom: 0;
            display: flex;
            align-items: center;
            opacity: 0.7;
          `}
        >
          {renderTypeIcon(alertData?.type || "error")}
        </DialogTitle>
        <DialogContent
          css={css`
            max-width: 500px;
          `}
        >
          <pre
            css={css`
              margin-bottom: 4px;
            `}
          >
            {alertData?.message || "오류가 발생했습니다."}
          </pre>
        </DialogContent>
        <DialogActions
          css={css`
            padding-bottom: 4px;
          `}
        >
          <div
            css={css`
              width: 100%;
              padding-top: 4px;
              border-top: 1px solid ${PALETTE.border};
              display: flex;
              justify-content: flex-end;
            `}
          >
            <BaseButton
              onClick={alertData?.confirmFunc || closeDialog}
              css={css`
                font-size: 14px;
              `}
            >
              확인
            </BaseButton>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}

const renderTypeIcon = (type: "error" | "warning" | "info" | "success") => {
  switch (type) {
    case "error":
      return (
        <ErrorIcon
          css={css`
            color: red;
          `}
        />
      );
    case "warning":
      return (
        <WarningIcon
          css={css`
            color: orange;
          `}
        />
      );
    case "info":
      return (
        <InfoIcon
          css={css`
            color: "blue";
          `}
        />
      );
    case "success":
      return (
        <CheckCircleIcon
          css={css`
            color: "green";
          `}
        />
      );
    default:
      return (
        <ErrorIcon
          css={css`
            color: red;
          `}
        />
      );
  }
};

export default AlertDialog;
